import { type CampaignSource, type IRebateCampaign } from '../../../types/campaign.types';
import {
  buildRebateCardInfo,
  isRebateSource,
  REBATE_CARD_INFO_PLACEHOLDER,
  type RebateCardData,
} from '../../../utils/variants/rebateHelpers';

export { type RebateCardData } from '../../../utils/variants/rebateHelpers';

/**
 * Rebate card data — the player's claimed win and current level progress.
 *
 * Unlike prizes (prize-pop) and the leaderboard (tournaments), these are NOT
 * polled from a sub-endpoint: both arrive on the get-all campaign object
 * (`IRebateCampaign.userProgress`). This hook normalizes that already-fetched
 * data into display-ready strings within the unified `CampaignCardLiveData`
 * shape, so the shared, type-agnostic `useCampaignInfoItems` stays free of
 * rebate-specific type checks. It also becomes the home for real-time updates
 * if/when the dedicated page needs them. Self-gates by type.
 */
export const useRebateCardData = (campaign: CampaignSource | null | undefined, _isActive: boolean): RebateCardData => {
  const rebate =
    campaign && isRebateSource(campaign) && 'userProgress' in campaign ? (campaign as IRebateCampaign) : null;

  if (!rebate) {
    return {
      claimedWinDisplay: REBATE_CARD_INFO_PLACEHOLDER,
      progressDisplay: REBATE_CARD_INFO_PLACEHOLDER,
      showCurrency: false,
    };
  }

  return buildRebateCardInfo(rebate);
};
